import './animations.js';
import './tooltips.js';
import './app-view.mjs';
import './images.mjs';
import './livechat.mjs';
import './mcc-token-links.mjs';

window.addEventListener("DOMContentLoaded", () => {

  //Animate Hamburger on menu open/close
  const toggleNav = document.querySelector("#main-menu-collapse"),
    toggleBtn = document.querySelector("#navbarToggleBtn"),
    amHeader = document.querySelector(".site-header"),
    bodyTag = document.querySelector("body");

  if (toggleNav) {
    toggleNav.addEventListener("show.bs.collapse", () => {
      toggleBtn.classList.toggle("menu-open");
      bodyTag.classList.toggle("body-menu-open");
    });
    toggleNav.addEventListener("hide.bs.collapse", () => {
      toggleBtn.classList.toggle("menu-open");
      bodyTag.classList.toggle("body-menu-open");
    });
  }

  // Append dev tag to body for local development
  const url = window.location.href;
  if(url.includes('localhost') || url.includes('ddev.site')) {
    const dev = document.createElement("div");
    dev.classList.add(...["dev", "hide-links"]);
    document.body.appendChild(dev);
    const linkList = `
      <ul>
        <li><a href="/atmore/casino">atmore/casino</a></li>
        <li><a href="/rewards">rewards</a></li>
        <li><a href="/rewards/my-rewards">rewards/my-rewards</a></li>
        <li><a href="/resort/hotel-rooms-suites">resort/hotel-rooms-suites</a></li>
        <li><a href="/property-schedule">property-schedule</a></li>
        <li><a href="/resort/amenities">resort/amenities</a></li>
        <li><a href="/promotions">promotions</a></li>
        <li><a href="/profile/win-loss-statement">profile/win-loss-statement</a></li>
        <li><a href="/profile/my-reservations">profile/my-reservations</a></li>
        <li><a href="/book-now-4">book-now-4</a></li>
        <li><a href="/book-now-3">book-now-3</a></li>
        <li><a href="/atmore">atmore</a></li>
        <li><a href="/atmore/entertainment">atmore/entertainment</a></li>
        <li><a href="/profile">profile</a></li>
        <li><a href="/locations">locations</a></li>
        <li><a href="/book-now">book-now</a></li>
        <li><a href="/book-now-2">book-now-2</a></li>
        <li><a href="/atmore/resort/spa">atmore/resort/spa</a></li>
        <li><a href="/atmore/property-schedule">atmore/property-schedule</a></li>
        <li><a href="/atmore/dining">atmore/dining</a></li>
        <li><a href="/atmore/dining/fire-steakhouse">atmore/dining/fire-steakhouse</a></li>
        <li><a href="/atmore/contact-us">atmore/contact-us</a></li>
      </ul>
    `;
    dev.innerHTML = linkList;
    dev.addEventListener('click', (e) => {
      e.target.classList.remove('hide-links');
    });
  }

});
